__turbopack_context__.v({
  "black": "linkUrl-module-scss-module__Y22Snq__black",
  "danger": "linkUrl-module-scss-module__Y22Snq__danger",
  "info": "linkUrl-module-scss-module__Y22Snq__info",
  "large": "linkUrl-module-scss-module__Y22Snq__large",
  "light": "linkUrl-module-scss-module__Y22Snq__light",
  "link": "linkUrl-module-scss-module__Y22Snq__link",
  "medium": "linkUrl-module-scss-module__Y22Snq__medium",
  "outline": "linkUrl-module-scss-module__Y22Snq__outline",
  "primary": "linkUrl-module-scss-module__Y22Snq__primary",
  "secondary": "linkUrl-module-scss-module__Y22Snq__secondary",
  "separator": "linkUrl-module-scss-module__Y22Snq__separator",
  "small": "linkUrl-module-scss-module__Y22Snq__small",
  "success": "linkUrl-module-scss-module__Y22Snq__success",
  "warning": "linkUrl-module-scss-module__Y22Snq__warning",
});
